export default __webpack_public_path__ + "static/media/ghost.edecfb29.svg";